export enum LibraryTemplateType {
  DELIVERABLE = 'DELIVERABLE',
  FIXED_COST = 'FIXED_COST',
  COMPONENT = ' COMPONENT',
}
